import { wallets as keplrWallets } from '@cosmos-kit/keplr-extension'
import { ChainProvider } from '@cosmos-kit/react'
import { type PropsWithChildren } from 'react'

import { bridgelessAssetList, bridgelessChainRegistry } from '@/config'

export default function CosmosKitProvider({ children }: PropsWithChildren) {
  return (
    <ChainProvider
      chains={bridgelessChainRegistry}
      assetLists={bridgelessAssetList}
      wallets={keplrWallets}
      throwErrors={false}
      modalTheme={{
        defaultTheme: 'dark',

        modalChildrenClassName: 'cosmoskit-modal-children',

        modalContentStyles: {
          borderRadius: 'var(--radius-lg)',
          backgroundColor: 'var(--card)',
        },
        overrides: {
          'connect-modal-wallet-button': {
            bg: {
              light: 'var(--input)',
              dark: 'var(--input)',
            },
            borderColor: {
              light: 'var(--border)',
              dark: 'var(--border)',
            },
            hoverBg: {
              light: 'color-mix(in oklab, var(--input) 92%, white)',
              dark: 'color-mix(in oklab, var(--input) 92%, white)',
            },
            activeBg: {
              light: 'color-mix(in oklab, var(--input) 88%, black)',
              dark: 'color-mix(in oklab, var(--input) 88%, black)',
            },
            color: {
              light: 'var(--foreground)',
              dark: 'var(--foreground)',
            },
          },
        },
      }}
    >
      {children}
    </ChainProvider>
  )
}
